
import RowVertical from "../../../assets/duotone/RowVertical.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RowVerticalIcon({ className, dataTestid = "RowVerticalIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <RowVertical data-testid={dataTestid} className={classes} {...rest} />
  );
}
